import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Helpers from "../Config/Helpers";
import { Link, useNavigate, useParams } from "react-router-dom";
import SuccessBtn from "../Components/SuccessBtn";
import "izitoast/dist/css/iziToast.min.css";

function Permissions() {
  let checkedInit = {
    checked_tabs: [],
    checked_pers: [],
  };
  const [btnLoading, setBtnLoading] = useState(false);
  const [checked, setChecked] = useState(checkedInit);
  const [tabs, setTabs] = useState([]);

  const { role_id } = useParams();
  const { role_name } = useParams();

  let navigate = useNavigate();
  const getPermissions = useCallback(() => {
    axios
      .get(`${Helpers.baseUrl}/permissions/get-permissions/${role_id}`, Helpers.headers)
      .then((response) => {
        let pers = response.data;
        let check = {
          role_id : role_id,
          checked_tabs: [],
          checked_pers: [],
        };
        for (let i = 0; i < pers.length; i++) {
            check.checked_tabs.push(pers[i].tab_link);
            if (pers[i].can_create === 1) {
              check.checked_pers.push(`${pers[i].tab_link}-add`);
            }
            if (pers[i].can_update === 1) {
              check.checked_pers.push(`${pers[i].tab_link}-update`);
            }
            if (pers[i].can_delete === 1) {
              check.checked_pers.push(`${pers[i].tab_link}-delete`);
            }         
        }

        setChecked(check);
      })
      .catch((error) => {
        Helpers.unauthenticated(error, navigate);
      });
  }, [navigate, role_id]);

  const getTabs = useCallback(() => {
    axios.get(`${Helpers.baseUrl}/tabs`, Helpers.headers).then((response) => {
      const availableTabs = response.data;
      setTabs(availableTabs.some((tab) => tab.tab_link === "/user/locations")
        ? availableTabs
        : [...availableTabs, { _id: "locations", tab_name: "Locations", tab_link: "/user/locations" }]);
    });
  }, []);
  const handleSavePermission = (e) => {
    e.preventDefault();
    setBtnLoading(true);


    axios
      .post(`${Helpers.baseUrl}/permissions/save`, checked, Helpers.headers)
      .then((response) => {
        getPermissions();
        Helpers.toast("success", "Permission saved successfully");
        navigate("/user/roles");
        setBtnLoading(false);
      })
      .catch((error) => {
        Helpers.toast("error", error.response.data.message);
        Helpers.error_response(error);
        setBtnLoading(false);
      });
  };

  const handleCheck = (e) =>{
    const tab_link = e.target.value;
    const checked_tabs = checked.checked_tabs;
    const checked_pers = checked.checked_pers;
    if (checked_tabs.includes(tab_link)) {
      const index = checked_tabs.findIndex(tab => tab === tab_link);
      checked_tabs.splice(index, 1);
      if (checked_pers.includes(tab_link+'-add')) {
        const index = checked_pers.findIndex(per => per === tab_link+'-add');
        checked_pers.splice(index, 1); 
      }
      if (checked_pers.includes(tab_link+'-update')) {
        const index = checked_pers.findIndex(per => per === tab_link+'-update');
        checked_pers.splice(index, 1);
      }
      if (checked_pers.includes(tab_link+'-delete')) {
        const index = checked_pers.findIndex(per => per === tab_link+'-delete');
        checked_pers.splice(index, 1);
      }

      setChecked({...checked, checked_tabs:checked_tabs, checked_pers:checked_pers});

    }else{
      checked_tabs.push(tab_link);
      setChecked({...checked, checked_tabs:checked_tabs});
    }

  }

  const handleCheckPers = (e) =>{
    const tab_per = e.target.value;
    console.log(tab_per);
    const checked_pers = checked.checked_pers;
    if (checked_pers.includes(tab_per)) {
      const index = checked_pers.findIndex(tab => tab === tab_per);
      checked_pers.splice(index, 1);
      setChecked({...checked, checked_pers:checked_pers});

    }else{
      checked_pers.push(tab_per);
      setChecked({...checked, checked_pers:checked_pers});
    }

    console.log(checked);
  }

  useEffect(() => {
    getTabs();
    getPermissions();
  }, [getPermissions, getTabs]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">Manage Permissions</h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header row">
                <div className="col-6">
                  <h3>
                    <img
                      src={require("../images/icons/permissions.png")}
                      alt="home"
                      style={{ height: 40, marginRight: 10 }}
                    />{" "}
                    Manage Permissions for {role_name}
                  </h3>
                </div>
                <div className="col-6 text-end">
                  <Link to={`/user/roles`} className="btn btn-success text-end">Back to Roles</Link>

                </div>
              </div>
              <div className="card-body border-bottom">
                <div
                  className="row"
                  
                >
                {
                  tabs.map((tab)=>{
                    return(
                      <div className="col-4" key={tab._id}>
                        <div className="card">
                          <div className="card-header bg-light">
                            <div
                              className="form-check-outline form-check-success"
                              style={{ fontSize: "18px" }}
                            >
                              <input
                                className="form-check-input m-2"
                                id={tab._id}
                                type="checkbox"
                                value={`${tab.tab_link}`}
                                onChange={handleCheck}
                                checked={checked.checked_tabs.includes(`${tab.tab_link}`)}

                              />
                              <label
                                className="form-check-label m-1"
                                htmlFor={tab._id}
                              >
                                Allow {tab.tab_name}
                              </label>
                            </div>
                          </div>
                          <div className="card-body">
                            <div
                              className="form-check-outline form-check-success form-check-inline"
                              style={{ fontSize: "16px" }}
                            >
                              <input
                                className="form-check-input m-2"
                                type="checkbox"
                                id={`${tab._id}-add`}
                                value={`${tab.tab_link}-add`}
                                checked={checked.checked_pers.includes(`${tab.tab_link}-add`)}
                                onChange={handleCheckPers}
                              />
                              <label
                                className="form-check-label m-1"
                                htmlFor={`${tab._id}-add`}
                              >
                                Add
                              </label>
                            </div>
                            <div
                              className="form-check-outline form-check-success form-check-inline"
                              style={{ fontSize: "16px" }}
                            >
                              <input
                                className="form-check-input m-2"
                                type="checkbox"
                                id={`${tab._id}-update`}
                                value={`${tab.tab_link}-update`}
                                checked={checked.checked_pers.includes(`${tab.tab_link}-update`)}
                                onChange={handleCheckPers}

                              />
                              <label
                                className="form-check-label m-1"
                                htmlFor={`${tab._id}-update`}
                              >
                                Update
                              </label>
                            </div>
                            <div
                              className="form-check-outline form-check-success form-check-inline"
                              style={{ fontSize: "16px" }}
                            >
                              <input
                                className="form-check-input m-2"
                                type="checkbox"
                                id={`${tab._id}-delete`}
                                value={`${tab.tab_link}-delete`}
                                onChange={handleCheckPers}
                                checked={checked.checked_pers.includes(`${tab.tab_link}-delete`)}
                                

                              />
                              <label
                                className="form-check-label m-1"
                                htmlFor={`${tab._id}-delete`}
                              >
                                Delete
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
                </div>
                <div className="row mt-3">
                  <div className="col-3">
                    <SuccessBtn
                      text="Save Permissions"
                      loading={btnLoading}
                      onClick={handleSavePermission}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Permissions;
